export default "__VITE_ASSET__C5ct9a75__"